<template>
    <div>
        <ValidationObserver class="form" id="addCard" ref="cardCreateInfoForm">
            <div class="form-group row mb-0 align-items-end">
                <div class="col-md-6 col-md-6">
                    <ValidationProvider class="form-group mb-0" name="Card Type" rules="required" v-slot="{ errors }">
                        <label class="lbl lbl-required" for="card_type">Card Type</label>
                        <select id="card_type" class="custom-select mb-1" v-model="payment.card_type">
                            <option :value="null" disabled>Select One</option>
                            <option
                                v-for="type in cardList"
                                :key="type.id"
                                :value="type.name"
                            >
                                {{ type.name.replace('_', ' ').ucwords() }}
                            </option>
                        </select>

                        <div class="form-group field-validation-error">
                            {{ errors[0] }}
                        </div>
                    </ValidationProvider>
                </div>
                <div class="col-md-6 col-md-6">
                    <div class="form-group">
                        <div class="cards-img-block_wrap">
                            <img
                                v-for="card in cardList"
                                :src="`/img/${card.name}.png`"
                                :alt="card.name.replace('_', ' ')"
                                :class="{'selected-card': payment.card_type === card.name}"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row mb-0 align-items-center">
                <label class="col-lg-12 lbl lbl-required">Cardholder Name</label>
                <div class="col-12">
                    <div class="row justify-content-between dashed-bb">
                        <ValidationProvider class="col-lg-6" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <input type="text" placeholder='First Name' class="form-control mb-1" v-model="payment.card_first_name">
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                        <ValidationProvider class="col-lg-6" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <input type="text" placeholder="Last Name" class="form-control mb-1" v-model="payment.card_last_name">
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
            </div>
            <div class="form-group row mb-0">
                <ValidationProvider class="col-sm-12 col-md-6" name="Card Number" rules="required|min:13|max:16" v-slot="{ errors }">
                    <label class="lbl lbl-required">Card Number</label>
                    <input
                        type="text"
                        disabled
                        class="form-control mb-1"
                        :placeholder="inputCardNumber"
                        v-if="input_payment"
                        v-mask="['#### #### #### ####']"
                        v-model="payment.card_number"
                    >
                    <the-mask
                        type="text"
                        class="form-control mb-1"
                        :mask="['#### #### #### ####']"
                        :placeholder="inputCardNumber"
                        v-else
                        v-model="payment.card_number"
                    >
                    </the-mask>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <div class="col-sm-12 col-md-6">
                    <div class="form-group row align-items-center mb-0">
                        <label class="col-lg-12 lbl lbl-required">Expiration Date</label>
                        <div class="col-12">
                            <div class="row justify-content-between dashed-bb">
                                <ValidationProvider class="col-md-6 col-md-6" name="Card Expiration Month" rules="required" v-slot="{ errors }">
                                    <select class="custom-select mb-1" v-model="payment.card_expiration_month">
                                        <option :value="null" disabled>MM</option>
                                        <option v-for="month in 12" :value="month.toString()">{{ month < 10 ? '0' + month : month }}</option>
                                    </select>

                                    <div class="form-group field-validation-error">
                                        {{ errors[0] }}
                                    </div>
                                </ValidationProvider>
                                <ValidationProvider class="col-md-6 col-md-6" name="Card Expiration Year" rules="required" v-slot="{ errors }">
                                    <select class="custom-select mb-1" v-model="payment.card_expiration_year">
                                        <option :value="null" disabled>YYYY</option>
                                        <option v-for="(year, index) in 21" :key="year" :value="(index + currentYear).toString()">{{ index + currentYear }}</option>
                                    </select>

                                    <div class="form-group field-validation-error">
                                        {{ errors[0] }}
                                    </div>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationProvider class="col-sm-12 col-md-6" name="Card CVV" rules="required|min:3|max:4" v-slot="{ errors }">
                    <label class="lbl lbl-required">CVV</label>
                    <input
                        type="password"
                        disabled
                        class="form-control mb-1"
                        :placeholder="inputCardCvv"
                        :mask="['####','###']"
                        v-if="input_payment"
                        v-model="payment.card_number"
                    >
                    <the-mask
                        type="password"
                        class="form-control mb-1"
                        :mask="['####','###']"
                        :placeholder="inputCardCvv"
                        v-else
                        v-model="payment.card_cvv"
                    >
                    </the-mask>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
            </div>
        </ValidationObserver>
        <ValidationObserver class="form" id="addAdress" ref="billingCreateInfoForm">
            <div class="form-group row mb-0">
                <ValidationProvider class="col-sm-12 col-md-6" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                    <label class="lbl lbl-required" for="first_name">First Name</label>
                    <input
                        id="first_name"
                        type="text"
                        placeholder="First Name"
                        class="form-control mb-1"
                        v-model="billing.billing_first_name"
                    >

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-sm-12 col-md-6" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                    <label class="lbl lbl-required" for="last_name">Last Name</label>
                    <input
                        id="last_name"
                        type="text"
                        placeholder="Last Name"
                        class="form-control mb-1"
                        v-model="billing.billing_last_name"
                    >

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-sm-12 col-md-12 googleAutoComplete" name="Street Address" rules="required|max:50" v-slot="{ errors }">
                    <label class="lbl lbl-required" for="address">Street Address</label>
                    <input
                        id="address"
                        type="search"
                        class="form-control mb-1"
                        autocomplete="off"
                        v-model="billing.billing_street"
                    >

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-md-6 col-md-6" name="Country" rules="required" v-slot="{ errors }">
                    <div class="form-group mb-0">
                        <label class="lbl lbl-required">Country</label>
                        <select class="custom-select" aria-label="country" v-model="billing.billing_country_id">
                            <option :value="null" disabled>Select One</option>
                            <option v-for="country in input_countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                        </select>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-sm-12 col-md-6" name="City" rules="required|min:3|max:50" v-slot="{ errors }">
                    <label class="lbl lbl-required">City</label>
                    <input
                        type="text"
                        placeholder="City"
                        class="form-control mb-1"
                        aria-label="city"
                        v-model="billing.billing_city"
                    >

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-md-6 col-md-6" name="State" rules="required" v-slot="{ errors }">
                    <div class="form-group mb-0">
                        <label class="lbl lbl-required">State</label>
                        <select class="custom-select mb-1" aria-label="state" v-model="billing.billing_state_id">
                            <option :value="null" disabled>Select One</option>
                            <option v-for="state in input_states" :value="state.id" :key="state.id">{{ state.name }}</option>
                        </select>
                    </div>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-sm-12 col-md-6" name="Zip" rules="required|numeric|min:4|max:5" v-slot="{ errors }">
                    <label class="lbl lbl-required">Zip Code</label>
                    <input
                        type="text"
                        placeholder="Zip"
                        class="form-control mb-1"
                        aria-label="zip"
                        v-mask="'#####'"
                        v-model="billing.billing_zip_code"
                    >

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-sm-12 col-md-6" name="Email Address" rules="required|email" v-slot="{ errors }">
                    <label class="lbl lbl-required">Email Address</label>
                    <input
                        type="email"
                        placeholder="Email Address"
                        class="form-control mb-1"
                        aria-label="email"
                        v-model="billing.billing_email"
                    >

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <ValidationProvider class="col-sm-12 col-md-6" name="Phone Number" rules="required|min:10|max:10" v-slot="{ errors }">
                    <label class="lbl lbl-required">Phone Number</label>
                    <the-mask
                        type="tel"
                        placeholder="Phone Number"
                        class="form-control mb-1"
                        aria-label="phone number"
                        mask="+1 (###) ###-####"
                        v-model="billing.billing_phone"
                    >
                    </the-mask>

                    <div class="form-group field-validation-error">
                        {{ errors[0] }}
                    </div>
                </ValidationProvider>
                <div class="col-sm-12 col-md-12">
                    <div class="form-check">
                        <input
                            id="billing_default"
                            class="form-check-input-checkbox"
                            name="card_default"
                            type="checkbox"
                            :value="1"
                            v-model="billing.is_default"
                        >
                        <label class="form-check-label" for="billing_default">Set card as default</label>
                    </div>
                </div>
                <div class="col-12 mt-2">
                    <div class="buttons-bottom mt-4">
                        <a v-if="input_payment" href="/subscription/my-payment-method" class="btn btn-transparent">Cancel</a>
                        <a
                            class="btn btn-transparent"
                            data-toggle="collapse"
                            data-target="#addCardBlock"
                            aria-expanded="false"
                            aria-controls="addCardBlock"
                            v-else
                            @click="reset"
                        >
                            Cancel
                        </a>
                        <a class="btn" @click="validate">Save</a>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import { googleAutocomplete } from '../../mixins/google-autocomplete';

    export default {
        name: "PaymentForm",
        mixins: [ googleAutocomplete ],
        props: {
            input_countries: {
                type: Array,
                required: true
            },
            input_states: {
                type: Array,
                required: true
            },
            input_payment: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                payment: {
                    payment_type: 'authorizeNet',
                    card_type: null,
                    card_first_name: null,
                    card_last_name: null,
                    card_number: null,
                    card_expiration_month: null,
                    card_expiration_year: null,
                    card_cvv: null,
                },
                billing: {
                    billing_first_name: null,
                    billing_last_name: null,
                    billing_street: null,
                    billing_country_id: null,
                    billing_city: null,
                    billing_state_id: null,
                    billing_zip_code: null,
                    billing_email: null,
                    billing_phone: null,
                    is_default: null,
                },

                inputCardNumber: null,
                inputCardCvv: null
            }
        },
        mounted() {
            this.setPayments();
            this.autoCompleteStreetAddress(
                this,
                '.googleAutoComplete',
                'address',
                'billing',
                this.input_countries,
                this.input_states
            );
        },
        computed: {
            cardList() {
                return [
                    {
                        id: 1,
                        name: 'visa'
                    },
                    {
                        id: 2,
                        name: 'master_card'
                    },
                    {
                        id: 3,
                        name: 'discover'
                    },
                    {
                        id: 4,
                        name: 'american_express'
                    },
                ]
            },
            currentYear() {
                return new Date().getFullYear();
            },
        },
        methods: {
            reset() {
                for (const key in this.payment) {
                    if (this.payment.hasOwnProperty(key)) {
                        this.payment[key] = null;

                        if (key === 'payment_type') {
                            this.payment[key] = 'authorizeNet';
                        }
                    }
                }

                for (const key in this.billing) {
                    if (this.billing.hasOwnProperty(key)) {
                        this.billing[key] = null;
                    }
                }

                this.$nextTick(() => {
                    this.$refs.cardCreateInfoForm.reset();
                    this.$refs.billingCreateInfoForm.reset();
                })
            },
            setPayments() {
                if (this.input_payment) {
                    this.payment = {
                        payment_type: 'authorizeNet',
                        card_type: this.input_payment.card_type,
                        card_first_name: this.input_payment.card_first_name,
                        card_last_name: this.input_payment.card_last_name,
                        card_number: null,
                        card_expiration_month: this.input_payment.card_expiration_month,
                        card_expiration_year: this.input_payment.card_expiration_year,
                        card_cvv: null,
                    }

                    this.billing = {
                        billing_first_name: this.input_payment.billing_first_name,
                        billing_last_name: this.input_payment.billing_last_name,
                        billing_street: this.input_payment.billing_street,
                        billing_country_id: this.input_payment.billing_country_id,
                        billing_city: this.input_payment.billing_city,
                        billing_state_id: this.input_payment.billing_state_id,
                        billing_zip_code: this.input_payment.billing_zip_code,
                        billing_email: this.input_payment.billing_email,
                        billing_phone: this.input_payment.billing_phone,
                        is_default: this.input_payment.is_default
                    }

                    this.inputCardNumber = `${this.cardNumberFormat(this.input_payment.card_number.toString().slice(-4))}`;
                    this.inputCardCvv = '***';
                }
            },
            cardNumberFormat(card_number) {
                const MAX_CARD_LENGTH = 16;
                const zeroPad = (num, places) => String(num).padStart(places, '*');

                return zeroPad(card_number, MAX_CARD_LENGTH);
            },
            showLoadingMessage() {
                this.$swal.fire({
                    icon: 'info',
                    title: 'Please Wait!',
                    html: 'Your information is being uploaded',
                    allowOutsideClick: false,
                    showCancelButton: false,
                    showConfirmButton: false,
                    willOpen: () => {
                        this.$swal.showLoading();
                    }
                });
            },
            showErrorMessage(errors) {
                this.$swal.fire({
                    title: `The form contains some errors!`,
                    text: errors.join(', '),
                    icon: 'error',
                })
            },
            showServerErrorMessage(error) {
                setTimeout(() => {
                    this.$swal.fire({
                        title: `The form contains some errors!`,
                        text: error.response.data.errors[Object.keys(error.response.data.errors)[0]][0],
                        icon: 'error',
                    })
                }, 500);
            },
            validate() {
                (async () => {
                    const list = [
                        {
                            name: 'Card Information',
                            value: await this.$refs.cardCreateInfoForm.validate()
                        },
                        {
                            name: 'Billing Information',
                            value: await this.$refs.billingCreateInfoForm.validate()
                        },
                    ];
                    const form = Object.assign({},
                        this.payment,
                        this.billing,
                    );
                    const valid = list.every(form => form.value === true);
                    const errors = [];

                    list.forEach(form => {
                        if (!form.value) errors.push(form.name)
                    })

                    if (valid) {
                        this.showLoadingMessage();

                        if (this.input_payment) {
                            this.editPayment(`/payments/accounts/${this.input_payment.id}`, form);
                        } else {
                            this.createPayment('/payments/accounts', form);
                        }
                    } else {
                        this.showErrorMessage(errors);
                    }
                })();
            },
            createPayment(route, form) {
                axios.post(route, form)
                    .then(response => {
                        if (response) {
                            this.$swal.close();

                            setTimeout(() => {
                                this.$swal.fire({
                                    title: `Success!`,
                                    text: 'Payment method has been successfully created!',
                                    icon: 'success',
                                })
                            }, 500);

                            this.$emit('create', response.data);

                            $('#addCardBlock').collapse('hide');
                            this.reset();
                        }
                    })
                    .catch(error => {
                        this.$swal.close();

                        this.showServerErrorMessage(error);
                    })
            },
            editPayment(route, form) {
                axios.put(route, form)
                    .then(response => {
                        if (response) {
                            this.$swal.close();

                            setTimeout(() => {
                                this.$swal.fire({
                                    title: `Success!`,
                                    text: 'Payment method has been successfully updated!',
                                    icon: 'success',
                                }).then(() => {
                                    window.location.href = '/subscription/my-payment-method'
                                });
                            }, 500);

                        }
                    })
                    .catch(error => {
                        this.$swal.close();

                        this.showServerErrorMessage(error);
                    })
            },
        }
    }
</script>

<style scoped lang="less">
    .selected-card {
        border: 2px solid #f7c44e;
        border-radius: 5px;
    }

    .lbl.lbl-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 14px;
        font-weight: 400;
        padding-left: 5px;
    }

    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
        -webkit-appearance:none;
    }
</style>

